// Taşeron portalı — S19 yükleme sonrası modalı (D5 AI dalı + D6 elle giriş dalı; plan
// S19-D1/D2/D3, tasarım review §7). Belgeler'in `Belge Yükle`'si VE bir personelin doküman
// sayfasının aynı düğmesi (D7/D9) bu TEK bileşeni açar — hedef (firma/kişi) modalın İÇİNDE
// SEÇİLMEZ, nereden açıldığına göre KİLİTLİDİR (`subject` prop'u).
//
// SÖZLEŞME (DEĞİŞTİRİLMEDİ — `DocumentAnalysisProvider.tsx`): okunabilir dosyalar seçimde
// HEMEN yüklenir; `startUpload` okunamayanları YÜKLEMEDEN döner; `resolveUpload(analyze)`
// modal ÇÖZÜLÜNCE (Tamam/Esc/✕/Kaydet-başarı) TEK sefer çağrılır — `analyze=true` ertelenmiş
// analiz başlatmayı tetikler, `analyze=false` HİÇBİR KOŞULDA tetiklemez (AC26).
//
// ÜÇ KAPANIŞ YOLU, ÜÇ FARKLI SONUÇ (S19-D1'in "hiçbir belge evsiz kalmaz" garantisi VE
// S19-D3'ün "switch kapalıyken modelin OKUYACAĞI tek bir bayt bile YOKTUR" garantisi bir
// arada — ikisi çelişmez, koordinatör düzeltmesi):
//   1. `Tamam` / `Esc` / `✕` (Radix dismiss, hepsi AYNI — D5) → `resolveUpload(analyze)`,
//      switch'in O ANKİ değeriyle. Switch AÇIK → analiz sürer (S19-D1): onaylı belgeler o
//      analizin `sources[]`'i olur, hiçbiri evsiz kalmaz, sorulacak bir şey YOKTUR. Switch
//      KAPALI → kaydetmeden kapatma ASLA analiz BAŞLATMAZ (S19-D3/AC26 — yalnız `Kaydet`e
//      mahsus DEĞİL, Esc/✕/overlay için de geçerli), dolayısıyla onaylı belgeler için ne bir
//      link satırı ne de bir `DocumentAnalysis` satırı doğar. Bu yüzden kapanış ÖNCE SORAR
//      (`upload.discard.*` onay diyaloğu): onaylanırsa her yetim §8.5 `DELETE /documents/{uuid}`
//      ile SİLİNİR ve modal kapanır, `Vazgeç`te modal AÇIK kalır (dosyalar durur, kullanıcı
//      `Kaydet`e dönebilir).
//      ⚠️ Bu diyalog ESTETİK DEĞİL, düzeltmedir (S19 istemci güvenlik incelemesi F1): bu
//      belgeleri "bırakıp gitmek" onları hiçbir listede GÖRÜNMEYEN, hiçbir şeyin TOPLAMADIĞI
//      kalıcı yetimlere çevirirdi — Belgeler'in `stranded` şeridi ANALİZLERİ sayar (§20.3),
//      hiç BAŞLAMAMIŞ bir partiyi asla yüzeye çıkaramaz.
//   2. `Kaydet` (okunamayan dosyalar VE/VEYA switch KAPALIYKEN onaylanmış okunabilir dosyalar
//      için N alan grubu doldurulunca) → önce §8 yükle (yalnız henüz yüklenmemiş dosyalar için)
//      sonra §13.6/§15.2 link, SIRAYLA; zaten onaylı bir dosya (switch sonradan kapatılan ya da
//      stranded şeridinden gelen durum) VAR OLAN `documentUuid` ile SADECE link'lenir, yeniden
//      YÜKLENMEZ. Başarıda `resolveUpload(analyze)` — switch'in O ANKİ değeriyle.
//   3. `Yüklemeyi iptal et` → var olan `cancelAllUploads()` (yeni bir provider fonksiyonu YOK);
//      uçuştaki yüklemeler GERÇEKTEN iptal edilir, `resolveUpload` hiç çağrılmaz. Bu ARADA
//      `done` olmuş (§8'de ONAYLANMIŞ) dosyalar da §8.5 ile SİLİNİR — açık bir iptal ikinci
//      bir onay İSTEMEZ, ama arkasında tek bir yetim bırakmaz (aynı F1).
//
// Seçilen HER dosya önce `validateDocumentFile` + 10 dosyalık tavan ile süzülür — reddedilenler
// listelenir, ASLA sessizce düşürülmez (tasarım §7.5). Hepsi reddedildiyse modal yalnız bu
// listeyi + tek bir kapama eylemini gösterir (switch/kutu/form YOK — kararlaştıracak bir şey
// yok).
//
// D6'nın form gövdesi ödünç alması: `DocumentUploadModal.tsx`/`PersonnelDocumentUploadModal.tsx`
// yalnız SAF alan-grubu bileşenlerini (`ContractorDocumentFieldGroup`/`PersonnelDocumentFieldGroup`)
// verir; çoklu-dosya orkestrasyonu (N grup, yükle-sonra-link sırası, `resolveUpload`) TAMAMEN bu
// dosyada yaşar.
//
// BELGE TÜRLERİ (GL #7, tasarım review §4.1). Türler §27 kaydındandır (`company` ya da — `subject`
// varken — `personnel`). Kaydın yükleniyor/hata/boş durumu grupların ÜSTÜNDE TEK kez gösterilir
// (`DocumentTypesStatus`, her açılışta kaydı bir kez tazeler — D9); yüklenirken her grubun seçicisi
// devre dışıdır. Bir grup ancak SEÇİLEBİLİR bir türle ve — türün kuralı istiyorsa — bitiş tarihiyle
// tamamdır; `Kaydet`in kapalı olma sebebi grubun kendi alanında (yıldız + kural ipucu) ve kapalı
// bir `<details>` grubunun başlığında okunur.
//
// TÜR REDDİ GRUP BAŞINADIR (`useDocumentFieldGroups`, `documents/DocumentFieldGroups.tsx`).
// Sunucu bir grubun türünü `INVALID`/`INACTIVE` ile reddederse (§27.6 — tür bu arada pasifleşti)
// ondan ÖNCEKİ gruplar zaten link'lenmiştir (`fieldGroups.markLinked`; "Kaydedildi" kartına döner,
// `Kaydet`i kilitlemez): yalnız o grup temizlenir, hata onun seçicisinde, odak oraya; `Kaydet` o
// gruptan devam eder.
//
// SONUCU BELİRSİZ BAĞ SİLİNMEZ. Ağ hatası/`5xx`'te bağ sunucuda kaydedilmiş olabilir (yanıt
// kaybolmuştur); §8.5 DELETE koşulsuzdur. Bu yüzden:
//   - bu turda yüklenen (`pending`) dosya yalnız link KESİN reddedilirse (`4xx`) silinir
//     (`documentsApi.linkUploadedDocument`);
//   - onaylı (`confirmed`) bir grubun HERHANGİ bir link denemesi belirsiz bittiyse belgesi bir daha
//     ASLA kapanışın silme hedefi olmaz (`uncertainLinkGroupIdsRef`, yapışkan — sonraki bir 4xx
//     öncekinin kaydedilmediğini kanıtlamaz). Bedeli: bağ gerçekten kaydedilmediyse belge yetim
//     kalabilir; kayıtlı bir bağın dosyasını silmekten iyidir.
// Kaydetme ya da silme sürerken modal kapanmaz (`busy`) — uçuştaki bir link'in belgesi silme
// hedefine giremez.

import {
  Alert,
  Button,
  ConfirmDialog,
  MAX_ANALYSIS_FILES,
  MAX_ANALYSIS_TOTAL_BYTES,
  Modal,
  Switch,
  documentsApi,
  isAnalyzableDocumentFile,
  isDefinitiveRejection,
  isTypeFieldRejection,
  resolveApiErrorMessage,
  supplierContractorApi,
  validateDocumentFile,
} from '@isgportal/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TriangleAlert } from 'lucide-react';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type UploadQueueItem, useDocumentAnalysisQueue } from '../lib/DocumentAnalysisProvider';
import { supplierContractorKeys } from '../lib/supplierContractorKeys';
import {
  ExplainerBox,
  FailedUploadList,
  FileGroupLabel,
  FileSummaryHeader,
  type RejectedFile,
  RejectionList,
} from './UploadModalParts';
import { DocumentFieldGroupList, useDocumentFieldGroups } from './documents/DocumentFieldGroups';
import { DocumentTypesStatus } from './documents/DocumentTypeFields';

export interface UploadModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /**
   * Seçilen/bırakılan dosyaların YENİ bir `File[]` anlık görüntüsü (henüz doğrulanmamış).
   * Her farklı seçim için ÇAĞIRAN yeni bir dizi referansı vermelidir — modal aynı referansı
   * (aynı parti) tek sefer işler (doğrular + `startUpload` çağırır); tekrar render'larda
   * no-op'tur. Partiler arasında `[]` verin ya da `open=false` yapın.
   */
  files: File[];
  /** Aktif firma — önbellek tazeleme anahtarı (belge/personel-belgesi/firma özeti). */
  companyId: number | null;
  /**
   * Verilirse bu yükleme bir personelin sayfasından başlatılmıştır (D9): elle giriş dalı
   * §27 `personnel` türlerini sunar, kişi-kapsam satırı gösterilir, ve `userUuid` başlatma
   * isteğine `subjectUserUuid` olarak AYNEN geçer (§20.1). `null`/`undefined` → Belgeler
   * (firma-kapsamlı).
   */
  subject?: { userUuid: string; name: string } | null;
}

type ManualGroup =
  | { id: string; name: string; kind: 'pending'; file: File; documentUuid?: undefined }
  | { id: string; name: string; kind: 'confirmed'; file?: undefined; documentUuid: string };

/** Zaten §8'de onaylanmış (ya da elle tekrar denenip başarılı olmuş) bir kuyruk öğesinin
 * elle-giriş grup kimliği. Grup listesi (`manualGroups`) ile yetim taramaları
 * (`unlinkedDoneFromQueue`/`unlinkedRetriedUuids`) AYNI kimliği üretmek ZORUNDA — ikisi
 * ayrışırsa link'lenmiş bir belge yetim sanılıp SİLİNİR. */
function confirmedGroupId(queueItemId: string): string {
  return `confirmed-${queueItemId}`;
}

export function UploadModal({ open, onOpenChange, files, companyId, subject }: UploadModalProps) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { queue, startUpload, resolveUpload, cancelAllUploads } = useDocumentAnalysisQueue();
  // Elle giriş dalının kayıt entity'si — hedef modalın İÇİNDE seçilmez (dosya başı).
  const entity = subject ? 'personnel' : 'company';

  const [analyze, setAnalyze] = useState(true);
  const [rejected, setRejected] = useState<RejectedFile[]>([]);
  // KABUL EDİLEN dosyalar — `files` prop'u KULLANICININ SEÇTİĞİdir ve reddedilenleri de
  // içerir. Bu yüzeydeki HER sayı bu listeden türer (QA D3): eskiden başlık `files`'ı sayıp
  // "11 dosya" derken tepsi kabul edilen 10'u sayıyordu. Diyalogların `{{count}}`'u da aynı
  // ailededir — orada sayı bir adım DAHA dardır (yüklenmiş VE silinecek olanlar).
  const [acceptedFiles, setAcceptedFiles] = useState<File[]>([]);
  const [unreadableFiles, setUnreadableFiles] = useState<File[]>([]);
  // Elle giriş gruplarının değerleri + grup başına tür reddi + açık `<details>` + ret sonrası odak.
  const fieldGroups = useDocumentFieldGroups(entity);
  const resetFieldGroups = fieldGroups.reset;
  // Elle "Tekrar dene" — bir kuyruk öğesi `failed` olduktan SONRA kullanıcının tetiklediği
  // İKİNCİ, YEREL bir yükleme denemesi (bkz. dosya başı YENİ bölüm: "Başarısız otomatik
  // yükleme"). `retriedUuids`: öğe kimliğinden başarıyla alınan yeni `documentUuid`'e eşler —
  // dolduğu AN o öğe bir `confirmed` elle-giriş grubuna dönüşür (aşağıda `manualGroups`).
  // `retryingIds`: hangi öğelerin YENİDEN deneme isteği UÇUŞTA — aynı öğe için ikinci bir
  // tıklamayı engeller, buton `loading` gösterir.
  const [retriedUuids, setRetriedUuids] = useState<Record<string, string>>({});
  const [retryingIds, setRetryingIds] = useState<Set<string>>(new Set());
  // "Kapatırsan silinir" onayının hedefleri — `null` iken onay KAPALI. Liste durumda tutulur
  // çünkü diyaloğun metni SİLİNECEK dosya SAYISINI söyler (`{{count}}`) ve o sayı ne
  // `files.length`'tir (reddedilenler dahil olurdu) ne de silme ilerledikçe değişmelidir.
  // Diyalog açıkken kullanıcı başka bir şey yapamaz (modal), yani liste bayatlayamaz.
  const [discardTargets, setDiscardTargets] = useState<string[] | null>(null);

  // Bu partinin zaten İŞLENDİĞİNİ (doğrulandı + `startUpload` çağrıldı) izler — StrictMode'un
  // efekti iki kez çalıştırmasına karşı; `files` REFERANSI eşitliğiyle karşılaştırılır (yeni
  // bir seçim = yeni bir dizi).
  const processedFilesRef = useRef<File[] | null>(null);
  // Bu partinin `resolveUpload`'ı zaten çağrıldı mı — sağlama (provider zaten kendi
  // `resolvedRef`'iyle korur, burası ikinci bir katman).
  const batchResolvedRef = useRef(false);
  // Elle kaydette hangi grupların ZATEN yüklenip link'lendiği `fieldGroups.markLinked`'dedir —
  // yeniden deneme aynı grubu ikinci kez yüklemesin/link'lemesin diye.
  //
  // Link'i BELİRSİZ biten (ağ hatası/`5xx`) onaylı grupların kimlikleri — belgeleri kapanışta
  // SİLİNMEZ (dosya başı). Yapışkandır: aynı grubun sonraki bir `4xx`'i ilk denemenin kaydedilmediğini
  // kanıtlamaz.
  const uncertainLinkGroupIdsRef = useRef<Set<string>>(new Set());
  // Bu partide hangi belgeler ZATEN §8.5 ile silindi — silme kısmi başarısızlıktan sonra
  // yeniden denendiğinde aynı uuid'e ikinci bir DELETE (→ `404`) atılmasın diye.
  const discardedUuidsRef = useRef<Set<string>>(new Set());
  // YALNIZ `Yüklemeyi iptal et` için: o yol `cancelAllUploads()` ile kuyruğu BOŞALTIR, yani
  // silme başarısız olursa ikinci deneme hedef listesini kuyruktan bir daha HESAPLAYAMAZ (boş
  // liste = yetim sessizce arkada kalır). Liste bu yüzden saklanır. Kapatma-onayı yolu bunu
  // KULLANMAZ: orada kuyruk yerinde durur, her deneme canlı hesaplar — saklanmış bir liste ise
  // araya giren bir `Kaydet`ten sonra ARTIK LİNK'Lİ bir belgeyi silmeye kalkardı.
  const cancelDiscardRef = useRef<string[]>([]);

  // §8.5 `DELETE /documents/{uuid}` — TERK EDİLEN (onaylı ama link'lenmemiş) dosyaları siler.
  // SIRAYLA gider ve ilk hatada durur: kısmen silinmiş bir parti sessizce "başarılı" sayılırsa
  // düzeltmeye çalıştığımız yetimin ta kendisi geri gelir. Hata kullanıcıya gösterilir, modal
  // AÇIK kalır, yeniden denenebilir (silinmiş uuid'ler atlanır).
  const discardMutation = useMutation({
    mutationFn: async (uuids: string[]) => {
      for (const uuid of uuids) {
        if (discardedUuidsRef.current.has(uuid)) {
          continue;
        }
        await documentsApi.deleteDocument(uuid);
        discardedUuidsRef.current.add(uuid);
      }
    },
  });

  useEffect(() => {
    if (!open || files.length === 0 || processedFilesRef.current === files) {
      return;
    }
    processedFilesRef.current = files;
    batchResolvedRef.current = false;
    uncertainLinkGroupIdsRef.current.clear();
    discardedUuidsRef.current.clear();
    cancelDiscardRef.current = [];
    setAnalyze(true);
    resetFieldGroups();
    setDiscardTargets(null);
    setRetriedUuids({});
    setRetryingIds(new Set());
    discardMutation.reset();

    const accepted: File[] = [];
    const rejectedNext: RejectedFile[] = [];
    // Parti TAVANI İKİ boyutludur ve sunucu İKİSİNİ de dayatır (`documents.ts:146-156` —
    // `DocCheckOptions.MaxFilesPerAnalysis` + `MaxTotalBytes`). Dosya sayısını süzüp toplam
    // baytı süzmemek, 10 × 19 MB'lık bir partiyi TAMAMEN yükleyip sunucuya reddettirirdi —
    // yani her seferinde N tane taze yetim (güvenlik incelemesi F2, F1'i besleyen yol).
    let acceptedBytes = 0;
    files.forEach((file, index) => {
      const invalid = validateDocumentFile(file);
      if (invalid) {
        rejectedNext.push({ id: `${index}-${file.name}`, name: file.name, reason: invalid });
        return;
      }
      if (accepted.length >= MAX_ANALYSIS_FILES) {
        rejectedNext.push({ id: `${index}-${file.name}`, name: file.name, reason: 'overCap' });
        return;
      }
      if (acceptedBytes + file.size > MAX_ANALYSIS_TOTAL_BYTES) {
        rejectedNext.push({ id: `${index}-${file.name}`, name: file.name, reason: 'overSizeCap' });
        return;
      }
      accepted.push(file);
      acceptedBytes += file.size;
    });
    setRejected(rejectedNext);
    setAcceptedFiles(accepted);
    setUnreadableFiles(
      accepted.length > 0
        ? startUpload(accepted, { subjectUserUuid: subject?.userUuid ?? null })
        : [],
    );
  }, [open, files, startUpload, subject?.userUuid, discardMutation.reset, resetFieldGroups]);

  const manualGroups = useMemo<ManualGroup[]>(() => {
    const pending: ManualGroup[] = unreadableFiles.map((file, index) => ({
      id: `pending-${index}-${file.name}`,
      name: file.name,
      kind: 'pending',
      file,
    }));
    const confirmedFromQueue: ManualGroup[] = analyze
      ? []
      : queue
          .filter(
            (q): q is typeof q & { documentUuid: string } =>
              q.status === 'done' && q.documentUuid !== null,
          )
          .map((q) => ({
            id: confirmedGroupId(q.id),
            name: q.name,
            kind: 'confirmed' as const,
            documentUuid: q.documentUuid,
          }));
    // Başarısız bir otomatik yüklemenin elle YENİDEN denenip başarılı olduğu hâli — switch'in
    // O ANKİ değerinden BAĞIMSIZ her zaman elle bağlanır. Bu belge provider'ın
    // `confirmedDocumentUuids`'ine hiç GİRMEDİ (yükleme ilk seferinde başarısız oldu; ikinci
    // deneme burada, yerel bir `documentsApi.uploadDocument` çağrısıyla yapıldı) — yani
    // `analyze` açık olsa BİLE ertelenmiş `startDocumentAnalysis` çağrısı bu uuid'i hiçbir
    // zaman GÖRMEYECEK. Tek yol elle sınıflandırıp linklemek; `unlinkedRetriedUuids()` bu
    // yüzden aşağıda `analysisWillAdopt`'tan bağımsız her zaman taranır (F1, no orphan).
    const retried: ManualGroup[] = queue.flatMap((q) => {
      const uuid = retriedUuids[q.id];
      return q.status === 'failed' && uuid !== undefined
        ? [
            {
              id: confirmedGroupId(q.id),
              name: q.name,
              kind: 'confirmed' as const,
              documentUuid: uuid,
            },
          ]
        : [];
    });
    return [...pending, ...confirmedFromQueue, ...retried];
  }, [unreadableFiles, analyze, queue, retriedUuids]);

  // Elle kaydet, switch KAPALIYKEN henüz `done` olmamış (yüklemesi süren/kuyrukta) okunabilir
  // dosya varsa beklemeli — o dosyanın grubu henüz `documentUuid` taşımıyor.
  const queueUnsettled =
    !analyze && queue.some((q) => q.status === 'pending' || q.status === 'uploading');

  const hasManualWork = manualGroups.length > 0 || !analyze;
  // "Hiç grup yok" ile "grup var ama türü eksik" AYRI durumlardır — eskiden `manualGroups.
  // length > 0` koşulu ikisini TEK bir `false`'a çöktürüyordu. Bir `failed` kuyruk öğesi
  // (yeniden denenmemiş) hiçbir grup ÜRETMEZ (aşağıdaki `FailedUploadList` ayrı render
  // edilir, `manualGroups`'a asla KENDİLİĞİNDEN girmez) — switch kapalıyken bu durumda
  // `manualGroups.length` sıfır olsa BİLE `hasManualWork` (`!analyze`'den) `true` kalıyor ve
  // eski koşul `Kaydet`i KALICI olarak kilitliyordu (owner raporu — hiçbir alan yok, yine de
  // buton hiç açılmıyordu). Boş dizide `.every(...)` vacuously `true` döner; bu zaten doğru
  // semantiktir — dolduracak alan yoksa "eksik alan" da yoktur. Tamamlık = seçilebilir (aktif) bir
  // tür + kural istiyorsa bitiş tarihi (GL #7).
  const allGroupsValid = fieldGroups.allComplete(manualGroups.map((group) => group.id));
  // Bu partide doc-check'in OKUYABİLECEĞİ kaç dosya var — kabul edilenlerden okunamayanlar
  // düşülür. SIFIRSA (ör. tek bir `.docx`) hiçbir şey yüklenmemiştir ve hiçbir şey
  // okunmayacaktır: ne "alındı, okunuyor" başlığı, ne açıklayıcı kutu, ne de anahtar
  // gösterilir — üçü de olmayan bir şeyi iddia ederdi (tasarım incelemesi #2, `offSafeHint`
  // ile AYNI kusur sınıfı).
  const readableCount = acceptedFiles.length - unreadableFiles.length;

  // `queue`'daki HER öğe `readableAcceptedFiles`'ın AYNI indeksindeki `File`'dan doğar —
  // provider `startUpload` (`DocumentAnalysisProvider.tsx`) `accepted.filter(
  // isAnalyzableDocumentFile)`'i AYNI sırayla kuyruk öğelerine çevirir ve o sıra sonradan HİÇ
  // değişmez (yalnız `status` alanları güncellenir, dizi yeniden sıralanmaz). Süzgeç burada
  // AYNI girdi (`acceptedFiles`) üzerinde YENİDEN kurulur ki başarısız bir yüklemenin `File`'ı
  // elle tekrar denenebilsin — provider `UploadQueueItem`'da `File`'ı SAKLAMAZ (yalnız
  // ad/boyut), bu yüzden burada YENİDEN türetmek zorundayız.
  const readableAcceptedFiles = acceptedFiles.filter(isAnalyzableDocumentFile);

  function fileForQueueItem(item: UploadQueueItem): File | undefined {
    const index = queue.findIndex((q) => q.id === item.id);
    return index >= 0 ? readableAcceptedFiles[index] : undefined;
  }

  /** Hâlâ `failed` VE henüz elle tekrar denenip başarılı OLMAMIŞ öğeler — `FailedUploadList`
   * yalnız bunları gösterir; bir öğe tekrar denemede başarılı olur olmaz `retriedUuids`
   * dolar, buradan düşer ve `manualGroups` içinde normal bir elle-giriş kartı olarak belirir. */
  const stillFailedItems = queue.filter(
    (item) => item.status === 'failed' && retriedUuids[item.id] === undefined,
  );

  function handleRetryItem(item: UploadQueueItem) {
    if (retryingIds.has(item.id)) {
      return; // Aynı öğe için ikinci bir eşzamanlı deneme YOK.
    }
    const file = fileForQueueItem(item);
    if (!file) {
      return; // Savunma amaçlı — pratikte HER `failed` öğenin bir karşılığı olmalı.
    }
    setRetryingIds((prev) => new Set(prev).add(item.id));
    void documentsApi
      .uploadDocument(file)
      .then((uploaded) => {
        setRetriedUuids((prev) => ({ ...prev, [item.id]: uploaded.uuid }));
      })
      .catch(() => {
        // Yeniden deneme de başarısız oldu — öğe `failed` görünmeye devam eder (satır zaten
        // "Yüklenemedi" der, ikinci bir sebep UYDURULMAZ), buton tekrar tıklanabilir olur.
      })
      .finally(() => {
        setRetryingIds((prev) => {
          const next = new Set(prev);
          next.delete(item.id);
          return next;
        });
      });
  }

  // Kaydedilecek/ilerletilecek GERÇEKTEN hiçbir şey yoksa (her okunabilir dosya `failed`
  // oldu, hiçbiri elle tekrar denenip kurtarılmadı, doldurulacak bir grup da yok) `Kaydet`/
  // `Tamam` GÖSTERİLMEZ — ikisi de burada YALAN söylerdi: `Tamam` `resolveUpload`u boş bir
  // `documentUuids[]` ile çağırır (provider sessizce no-op eder) ve modal "başarılı"
  // görünümüyle kapanır, oysa TEK bir belge bile kaydedilmedi. Footer bunun yerine yalnız
  // gerçek eylemleri gösterir: gövdedeki her satırın kendi "Tekrar dene"si + burada kalan
  // `Yüklemeyi iptal et` (kapatma).
  const doneCount = queue.filter((q) => q.status === 'done').length;
  const nothingToSave =
    !queueUnsettled && manualGroups.length === 0 && doneCount === 0 && stillFailedItems.length > 0;

  function resolveAndClose(analyzeValue: boolean) {
    if (!batchResolvedRef.current) {
      batchResolvedRef.current = true;
      if (acceptedFiles.length > 0) {
        resolveUpload(analyzeValue);
      }
    }
    onOpenChange(false);
  }

  /**
   * Onaylı bir grubun belgesi kapanışta silinebilir mi: link'i hiç denenmedi ya da her denemesi
   * KESİN reddedildi (`4xx`). Bağlandıysa ya da bir denemesi belirsiz bittiyse (dosya başı) HAYIR.
   */
  function mayDiscard(groupId: string): boolean {
    return !fieldGroups.isLinkedNow(groupId) && !uncertainLinkGroupIdsRef.current.has(groupId);
  }

  /**
   * §8'de ONAYLANMIŞ (`done`) ama bu modalda HENÜZ link'lenmemiş dosyaların `documentUuid`'leri
   * — modal onları arkada bırakırsa ne bir §13.6/§15.2 link satırı ne de bir `DocumentAnalysis`
   * satırı olur; hiçbir listede görünmez, hiçbir şey toplamaz (güvenlik incelemesi F1). Kaynak
   * KUYRUKTUR, `manualGroups` DEĞİL: switch AÇIKKEN o liste `confirmed` grupları hiç
   * üretmez, oysa `Yüklemeyi iptal et` o durumda da yetim bırakabilir.
   */
  function unlinkedDoneFromQueue(): string[] {
    return queue.flatMap((item) =>
      item.status === 'done' && item.documentUuid !== null && mayDiscard(confirmedGroupId(item.id))
        ? [item.documentUuid]
        : [],
    );
  }

  /**
   * Elle "Tekrar dene" ile YENİDEN yüklenip başarılı olmuş `failed` öğelerin belge kimlikleri
   * — bunlar `manualGroups`'un İÇİNDE render edilir (yukarıdaki not) ama henüz LİNK'lenmedi.
   * `unlinkedDoneFromQueue`'dan FARKLI olarak `analysisWillAdopt`'tan bağımsız HER ZAMAN
   * taranır: provider'ın ertelenmiş `startDocumentAnalysis`'i bu uuid'i asla görmeyecek
   * (`confirmedDocumentUuids`'e hiç girmedi), yani switch açık/kapanış "analiz sürsün"
   * dese BİLE bu belge kimse tarafından SÜPÜRÜLMEZ — tek koruma budur.
   */
  function unlinkedRetriedUuids(): string[] {
    return queue.flatMap((item) => {
      const uuid = retriedUuids[item.id];
      return item.status === 'failed' && uuid !== undefined && mayDiscard(confirmedGroupId(item.id))
        ? [uuid]
        : [];
    });
  }

  /**
   * ŞİMDİ çıkılırsa yetim kalacak `documentUuid`'ler — kapanışın sorup sormayacağı ve neyi
   * sileceği bunun üzerinden karar verilir. `analysisWillAdopt` ise (switch AÇIK, parti iptal
   * EDİLMEMİŞ, `resolveUpload(true)` çağrılacak) onaylı belgeler başlayacak analizin kaynağı
   * olur — yetim YOKTUR. `Yüklemeyi iptal et` bunu HER ZAMAN `false` geçer: iptal, analizin
   * hiç başlamayacağı anlamına gelir. Silinemeden KALANLAR her koşulda eklenir — silme ağ
   * hatasıyla düşerse `Esc` ikinci bir kaçış yolu OLMAMALI. Yeniden denenmiş öğeler
   * (`unlinkedRetriedUuids`) `analysisWillAdopt`'TAN BAĞIMSIZ her koşulda eklenir (yukarıdaki
   * not) — o listeyi ikinci parametreye BAĞLAMAK yanlış olurdu.
   */
  function orphanUuids(analysisWillAdopt: boolean): string[] {
    const leftover = cancelDiscardRef.current.filter(
      (uuid) => !discardedUuidsRef.current.has(uuid),
    );
    const fromQueue = analysisWillAdopt ? [] : unlinkedDoneFromQueue();
    return [...new Set([...fromQueue, ...unlinkedRetriedUuids(), ...leftover])];
  }

  /** Çıkış yolunun ortak yarısı: uçuştaki yüklemeleri DURDUR (silme sürerken biten bir yükleme
   * silinemeyecek YENİ bir yetim üretirdi), hedef listesini SAKLA (`cancelAllUploads` kuyruğu
   * boşalttığından başarısız bir silmenin ikinci denemesi onu yeniden hesaplayamaz), sonra sil.
   * Silme başarılıysa `after()` — modal ancak o zaman kapanır. */
  function discardThen(uuids: string[], after: () => void) {
    cancelDiscardRef.current = uuids;
    cancelAllUploads();
    batchResolvedRef.current = true;
    if (uuids.length === 0) {
      after();
      return;
    }
    discardMutation.mutate(uuids, {
      onSuccess: () => {
        cancelDiscardRef.current = [];
        after();
      },
    });
  }

  async function linkGroup(groupId: string, documentUuid: string) {
    const body = fieldGroups.linkBody(groupId, documentUuid);
    if (subject) {
      await supplierContractorApi.linkSupplierPersonnelDocument(subject.userUuid, body);
    } else {
      await supplierContractorApi.linkSupplierDocument(body);
    }
  }

  const manualMutation = useMutation({
    mutationFn: async () => {
      for (const group of manualGroups) {
        if (fieldGroups.isLinkedNow(group.id)) {
          continue;
        }
        if (!fieldGroups.isComplete(group.id)) {
          continue; // Kaydet zaten devre dışı — savunma amaçlı.
        }
        if (group.kind === 'confirmed') {
          try {
            await linkGroup(group.id, group.documentUuid);
          } catch (error) {
            if (!isDefinitiveRejection(error)) {
              // Bağ kaydedilmiş olabilir → bu belge kapanışta ASLA silinmez (dosya başı).
              uncertainLinkGroupIdsRef.current.add(group.id);
            }
            throw error;
          }
        } else {
          // Bu turda §8'e yüklenen dosya: link KESİN reddedilirse silinir (dosya başı).
          const uploaded = await documentsApi.uploadDocument(group.file);
          await documentsApi.linkUploadedDocument(uploaded.uuid, () =>
            linkGroup(group.id, uploaded.uuid),
          );
        }
        fieldGroups.markLinked(group.id);
      }
    },
    // Tür reddi (§27.6) YALNIZ işlenen gruba aittir — önceki gruplar zaten link'lendi.
    onError: (error) => {
      fieldGroups.handleLinkError(error);
    },
    onSuccess: () => {
      if (subject) {
        queryClient.invalidateQueries({
          queryKey: supplierContractorKeys.personnelDocuments(companyId, subject.userUuid),
        });
      } else {
        queryClient.invalidateQueries({ queryKey: supplierContractorKeys.documents(companyId) });
        queryClient.invalidateQueries({ queryKey: supplierContractorKeys.contractor(companyId) });
      }
      resolveAndClose(analyze);
    },
  });

  // Silme sürerken hiçbir çıkış yolu ikinci kez tetiklenemez — yarıda kalmış bir DELETE
  // dizisinin üstüne ikinci bir çıkış, silinmemiş dosyayı arkada bırakırdı.
  const busy = manualMutation.isPending || discardMutation.isPending;
  const typeRejected = manualMutation.isError && isTypeFieldRejection(manualMutation.error);

  function handleDismiss(next: boolean) {
    // Radix'in TEK dismiss kanalı — Esc, ✕, overlay tıklaması. Üçü de AYNI (D5), ama SWİTCH'İN
    // O ANKİ değeriyle çözülür (koordinatör düzeltmesi, S19-D3): switch AÇIKKEN kapatma "analiz
    // sürsün" demektir ve onaylı belgeler o analizin kaynağı olur; switch KAPALIYKEN
    // kaydetmeden kapatma ASLA analiz başlatmaz — modelin OKUYACAĞI tek bir bayt bile YOKTUR
    // (AC26, kaydetmeden kapatma dahil).
    //
    // İkinci durumda onaylı `documentUuid[]` HİÇBİR YERE bağlanmaz: provider'ın
    // `confirmedDocumentUuids`'i yalnız bellek-içidir ve `stranded` şeridi ANALİZLERİ sayar,
    // hiç başlamamış bir partiyi asla yüzeye çıkaramaz. Bu yüzden burada kapanış ÖNCE SORAR;
    // onay verilirse dosyalar §8.5 ile silinir (F1). `open` prop'u çağıranda durduğundan
    // `return` etmek modalı GERÇEKTEN açık bırakır (kontrollü Radix Dialog).
    // Kaydetme/silme sürerken kapanmaz: uçuştaki bir link'in belgesi silme hedefine GİREMEZ (sonucu
    // henüz bilinmiyor) ve yarıda kalmış bir DELETE dizisinin üstüne ikinci bir çıkış binmez.
    if (next || busy) {
      return;
    }
    const orphans = orphanUuids(analyze && !batchResolvedRef.current);
    if (orphans.length > 0) {
      setDiscardTargets(orphans);
      return;
    }
    resolveAndClose(analyze);
  }

  function handleDiscardConfirm() {
    discardThen(discardTargets ?? [], () => {
      setDiscardTargets(null);
      // Silinmiş uuid'lerle analiz başlatmak `404`'ten başka bir şey üretmez — ayrıca AC26 bu
      // dalda başlatmayı zaten YASAKLAR; `false` bu yüzden AÇIKÇA geçilir.
      resolveAndClose(false);
    });
  }

  function handleCancelAll() {
    // Açık bir iptal — ikinci bir onay SORULMAZ (kullanıcı zaten "iptal" dedi), ama bu ana
    // kadar §8'de onaylanmış dosyalar SİLİNİR: bu yol da yetim bırakmaz (F1). İptal, analizin
    // hiç başlamayacağı anlamına geldiğinden `analysisWillAdopt` HER ZAMAN `false`.
    discardThen(orphanUuids(false), () => onOpenChange(false));
  }

  function handlePrimaryAction() {
    if (hasManualWork) {
      manualMutation.mutate();
    } else {
      resolveAndClose(true);
    }
  }

  if (!open || files.length === 0) {
    return null;
  }

  // Hepsi reddedildiyse: switch/kutu/form YOK — kararlaştırılacak bir şey yok, yalnız liste +
  // tek kapama eylemi (tasarım §7.5).
  if (acceptedFiles.length === 0) {
    return (
      <Modal
        open={open}
        onOpenChange={onOpenChange}
        // "Dosyalarınız alındı, okunuyor" DEĞİL (QA D8): bu dalda hiçbir dosya alınmadı ve
        // hiçbir şey okunmuyor — başlık altındaki tek içeriğin ("N dosya alınamadı") tam
        // tersini söylüyordu. `titleManual` de olmaz: girilecek bir bilgi yok.
        title={t('upload.modal.titleRejected')}
        size="md"
        closeLabel={t('common.close')}
        footer={
          <Button variant="secondary" onClick={() => onOpenChange(false)}>
            {t('common.close')}
          </Button>
        }
      >
        <RejectionList rejected={rejected} />
      </Modal>
    );
  }

  const footerLabel = hasManualWork ? t('upload.save') : t('upload.done');
  // Turuncu = ekrandaki TEK birincil eylem, ve o eylem "kullanıcının yapması GEREKEN" şeydir.
  // Doldurulacak bir form varsa (AC5'in karışık seçimi — anahtar AÇIKKEN de olabilir) o
  // `Kaydet`tir; yoksa modal yalnız kapatılır ve `Tamam` sessiz kalır. Eski koşul anahtarın
  // durumuna bakıyordu ve karışık seçimde gerçek eylemi ikincil gösteriyordu (tasarım
  // incelemesi #3).
  const footerVariant = hasManualWork ? 'primary' : 'secondary';
  const footerDisabled = hasManualWork ? !allGroupsValid || queueUnsettled || busy : busy;

  return (
    <>
      <Modal
        open={open}
        onOpenChange={handleDismiss}
        title={t(
          readableCount === 0
            ? 'upload.modal.titleManual'
            : analyze
              ? 'upload.modal.title'
              : 'upload.modal.titleOff',
        )}
        size="lg"
        closeLabel={t('common.close')}
        footer={
          <>
            <Button
              variant="ghost"
              onClick={handleCancelAll}
              loading={discardMutation.isPending}
              disabled={busy}
            >
              {t('upload.cancelAll')}
            </Button>
            {/* `nothingToSave` iken bu buton HİÇ render edilmez (yukarıdaki tanım) — ne
                "Kaydet" ne "Tamam" burada gerçek bir şey yapardı. Gerçek eylem gövdedeki her
                başarısız satırın kendi "Tekrar dene"si; kapatma zaten yukarıdaki butondur. */}
            {nothingToSave ? null : (
              <Button
                variant={footerVariant}
                onClick={handlePrimaryAction}
                loading={manualMutation.isPending}
                disabled={footerDisabled}
              >
                {footerLabel}
              </Button>
            )}
          </>
        }
      >
        <div className="flex flex-col gap-4">
          <RejectionList rejected={rejected} />
          {/* §8 yüklemesi (create → S3 PUT → confirm) başarısız olmuş kuyruk öğeleri — MIME
              yüzünden hiç DENENMEYEN `unreadableFiles`'tan (RejectionList/pending grup) FARKLI,
              bunlar OKUNABİLİR dosyalardı ama ağ/S3 tarafında düştüler (owner raporu). Ne
              `manualGroups`'a (hiçbir alan grubu ZORUNLU KILINMAZ) ne de yükleme kuyruğuna
              geri düşerler — kendi satırı + kendi "Tekrar dene"si; diğer dosyaların
              kaydını ENGELLEMEZLER (S19 owner raporu §2). */}
          <FailedUploadList
            items={stillFailedItems}
            retryingIds={retryingIds}
            onRetry={handleRetryItem}
            disabled={busy}
          />

          <FileSummaryHeader files={acceptedFiles} />
          {subject ? (
            <p className="text-sm text-fg">{t('upload.personnelScope', { name: subject.name })}</p>
          ) : null}

          {/* Okunabilir tek bir dosya bile yoksa anahtar GÖSTERİLMEZ: kapatılacak/açılacak bir
              okuma yoktur, ekranda kalması "istersen okuturum" diye YANLIŞ bir seçenek sunardı. */}
          {readableCount > 0 ? (
            <Switch
              checked={analyze}
              onChange={setAnalyze}
              disabled={busy}
              label={t(analyze ? 'upload.ai.switchLabelOn' : 'upload.ai.switchLabelOff')}
              description={analyze ? t('upload.ai.switchOffHint') : undefined}
            />
          ) : null}

          {/* Kuyruk ipucu anahtarın HEMEN ALTINDA — elle giriş bloğunun İÇİNDE değil. Yükleme
              sürerken anahtarı kapatan kullanıcı `Kaydet`i kapalı görür; sebebini söyleyen tek
              satır buysa, o satır grupların varlığına bağlı OLMAMALIDIR (tasarım incelemesi #4). */}
          {queueUnsettled ? (
            <p className="text-xs text-muted">
              {t('analysis.tray.uploading', {
                done: queue.filter((q) => q.status === 'done').length,
                total: queue.length,
              })}
            </p>
          ) : null}

          {readableCount > 0 && analyze && unreadableFiles.length === 0 ? <ExplainerBox /> : null}

          {manualGroups.length > 0 ? (
            <div className="flex flex-col gap-3 border-t border-border pt-4">
              {analyze && unreadableFiles.length > 0 ? (
                <div className="flex flex-col gap-3">
                  {/* Kutu YALNIZ okunacak bir dosya varken — hepsi okunamıyorsa "yüklediğinizde
                      ne olur" listesi bu partide GERÇEKLEŞMEYECEK şeyleri sayardı. */}
                  {readableCount > 0 ? <ExplainerBox /> : null}
                  <div className="flex items-start gap-2 rounded-md bg-surface-muted p-3">
                    {/* `text-warning-foreground` grafittir ve koyu temada grafit yüzeyin
                        ÜSTÜNDE 1.00:1 verir — glif kaybolur. Token'ın kendi kuralı "sarı ZEMİN
                        + grafit içerik"tir; tek başına bir glif için doğru olan `text-fg`. */}
                    <TriangleAlert className="mt-0.5 h-4 w-4 shrink-0 text-fg" aria-hidden="true" />
                    <div>
                      <p className="text-sm font-medium text-fg">
                        {t('upload.unreadable.title', { count: unreadableFiles.length })}
                      </p>
                      <p className="mt-0.5 text-xs text-muted">{t('upload.unreadable.hint')}</p>
                    </div>
                  </div>
                </div>
              ) : null}
              {/* Kaydın durumu TEK kez, grupların üstünde (dosya başı "BELGE TÜRLERİ"). */}
              <DocumentTypesStatus entity={entity} />
              <DocumentFieldGroupList
                groups={manualGroups}
                fieldGroups={fieldGroups}
                disabled={busy}
                renderName={(name) => <FileGroupLabel name={name} />}
              />
              {/* Burada BİR ZAMANLAR `upload.ai.closeHint` ("Kapatırsanız belgeler yapay zekâ
                  ile okunur."), SONRA `upload.ai.offSafeHint` ("Dosyalarınız kaybolmaz …
                  Belgelerim'de bekliyor") dururdu. İKİSİ DE KALDIRILDI ve ikisi de AYNI
                  sebeple: söyledikleri şey doğru değildi. `offSafeHint` tam olarak artık VAR
                  OLMAYAN bir kurtarma yolunu vaat ediyordu — kaydetmeden kapatılan bir dosya
                  Belgelerim'de BEKLEMEZ, hiçbir listede görünmez (güvenlik incelemesi F1).
                  Kapanış artık `upload.discard.*` onayıyla dosyaları SİLER; kullanıcıya bunu
                  söyleyen tek yer o diyalogdur ve orada söylenen doğrudur. */}
            </div>
          ) : null}

          {/* Tür reddi grubun kendi seçicisinin altındadır — burada ikinci kez gösterilmez. */}
          {manualMutation.isError && !typeRejected ? (
            <Alert tone="danger">{resolveApiErrorMessage(manualMutation.error, t)}</Alert>
          ) : null}
          {/* Silme hatası: onay diyaloğu AÇIKKEN orada gösterilir (aşağıdaki `error` prop'u) —
              burada yalnız `Yüklemeyi iptal et` dalının hatası kalır, çift gösterim olmaz. */}
          {discardMutation.isError && discardTargets === null ? (
            <Alert tone="danger">{resolveApiErrorMessage(discardMutation.error, t)}</Alert>
          ) : null}
        </div>
      </Modal>

      {/* Kaydetmeden kapatma = SİLME onayı (F1). Uygulamanın var olan onay primitifi
          (`ConfirmDialog` → `Modal` → Radix Dialog); yerel `window.confirm` YOK — o ne odak
          tuzağına ne tema/token'lara ne de i18n'e uyar. `Geri dön` modalı AÇIK bırakır:
          dosyalar durur, kullanıcı `Kaydet`e döner. `{{count}}` GERÇEKTEN silinecek dosya
          sayısıdır — seçilen dosya sayısı değil (bkz. `discardTargets`). */}
      <ConfirmDialog
        open={discardTargets !== null}
        onOpenChange={(next) => {
          if (!next && !discardMutation.isPending) {
            setDiscardTargets(null);
          }
        }}
        title={t('upload.discard.title')}
        body={t('upload.discard.body', { count: discardTargets?.length ?? 0 })}
        cancelLabel={t('upload.discard.cancel')}
        confirmLabel={t('upload.discard.confirm')}
        loading={discardMutation.isPending}
        error={discardMutation.isError ? discardMutation.error : undefined}
        onConfirm={handleDiscardConfirm}
      />
    </>
  );
}
